<template lang="html">
    <div class="cart" :class="{ active: isActive }">
        <div class="cart-half flex f-c">
            <div class="flex li jc-sb p-b">
                <h1 class="lundi">Panier</h1>
                <div class="cart-close link lundi" @click="closeCart">
                    Fermer
                </div>
            </div>
            <div v-if="cart.length > 0" class="cart-table f-1 flex f-c jc-sb">
                <div class="cart-items f-1">
                    <div v-for="item in cart" :key="item.id" class="cart-item li flex jc-c">
                        <div class="sli lundi">
                            {{ item.title }}
                        </div>
                        <div class="sli cap" v-if="item.size">
                            {{ item.size }}
                        </div>
                        <div class="sli link" v-if="item.quantity === 1" @click="removeFromCart(item)">
                            ×
                        </div>
                        <div v-else class="sli lundi link" @click="decreaseQuantity(item.id)">
                            &darr;
                        </div>
                        <div class="sli">
                            {{ item.quantity }}
                        </div>
                        <div class="sli lundi link" @click="increaseQuantity(item.id)">
                            ↑
                        </div>
                        <div class="sli tnum">{{ item.price | price }}</div>
                    </div>
                    <div class="cart-item li flex jc-c" v-if="shipping && !countryModal">
                        <div class="sli">Shipping</div>
                        <div class="sli titlecase">
                            {{ shipping.countries }}
                        </div>
                        <div class="sli pointer link" @click="countryModal = true; country = '0'">×</div>
                        <div class="sli">{{ shipping.price | price }}</div>
                    </div>
                    <div class="li flex jc-c" v-else>
                        <div class="sli tooltip black">
                            <select class="countr-select" name="country" id="country-select" v-model="country">
                                <option disabled value="0">Choisir votre pays &darr;</option>
                                <option v-for="countryOption in selects" :key="countryOption.code" :value="countryOption.code">
                                    {{ countryOption.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div v-if="shipping && shipping.price" class="cart-total li flex jc-c">
                        <div class="sli lundi">
                            Total
                        </div>
                        <div class="sli tnum">{{ (!pickup ? cartTotal + parseFloat(shipping.price) : cartTotal) | price }}
                        </div>
                    </div>
                </div>
                <div v-if="!checkOut && shipping && shipping.price" class="cart-checkout p-b flex jc-e">
                    <h1 class="lundi link" @click="checkout">Commander</h1>
                </div>
            </div>
            <div v-else class="cart-empty li flex jc-c">
                <div class="sli">
                    Votre panier est vide
                </div>
            </div>
        </div>

    </div>
</template>

<script>
const stripe = window.Stripe(process.env.VUE_APP_STRIPEKEY);
import axios from "axios";
import countries from "@/assets/countries.json";
import select from "@/assets/select.json";
const auth = {
    username: process.env.VUE_APP_USERNAME,
    password: process.env.VUE_APP_PASSWORD,
};
export default {
    data() {
        return {
            isActive: false,
            cartItems: true,
            checkOut: false,
            shippingCalculated: false,
            paymentComplete: false,
            pickup: false,
            country: "0",
            shipping: null,
            countries: countries,
            countryModal: true,
            selects: select,
            selected: 0,
        };
    },
    computed: {
        cart() {
            return this.$store.state.shop.cart;
        },
        cartTotal() {
            return this.$store.getters["shop/totalAmount"];
        },
        weightTotal() {
            return this.$store.getters["shop/weightTotal"];
        },
    },
    watch: {
        cartTotal() {
            this.calculateShipping();
        },
        country() {
            this.calculateShipping();
            this.countryModal = false;
        }
    },
    filters: {
        price(price) {
            return new Intl.NumberFormat('ch-DE', { style: 'currency', currency: 'CHF' }).format(price);
        },
        country(name) {
            return new Intl.DisplayNames(['en'], { type: 'region' }).of(name);
        }
    },
    mounted() {
        this.$root.$on("toggleCart", this.openCart);
        this.$root.$on("closeCart", this.closeCart);
    },
    beforeDestroy() {
        this.$root.$off("toggleCart", this.openCart);
        this.$root.$off("closeCart", this.closeCart);
    },
    methods: {
        openCart() {
            this.isActive = true;
            this.$root.$emit("closeNewsletter");
        },
        closeCart() {
            this.isActive = false;
            this.checkOut = false;
            if (this.paymentComplete) {
                this.paymentComplete = false;
            }
        },
        removeFromCart(id) {
            this.$store.commit("shop/removeFromCart", id);
        },
        increaseQuantity(id) {
            this.$store.commit("shop/increaseItem", id);
        },
        decreaseQuantity(id) {
            this.$store.commit("shop/decreaseItem", id);
        },
        getRegion() {
            let region = null;
            for (var i = 0; i < countries.length; i++) {
                if (countries[i].countries.includes(this.country)) {
                    region = countries[i];
                    break;
                }
            }
            if (!region) {
                return null;
            }
            return region.region;
        },
        calculateShipping() {
            // Only calculate shipping if a country is selected
            if (!this.country || this.country === "0" || this.country === 0) {
                this.shipping = null;
                return;
            }

            const region = this.getRegion();
            if (!region) {
                this.shipping = null;
                return;
            }

            axios
                .post(
                    "/api/stripe/shipping/calculate",
                    {
                        weight: this.weightTotal,
                        region: region,
                    },
                    { auth }
                )
                .then((res) => {
                    this.shipping = res.data[0];
                })
                .catch(() => {
                    this.shipping = null;
                });
        },
        checkout() {
            // Safety check: ensure shipping is calculated
            if (!this.shipping || !this.shipping.price) {
                return;
            }

            let items = Object.values(this.cart).map((item) => ({
                price_data: {
                    currency: "chf",
                    product_data: {
                        name: item.title + " (" + item.size + ")",
                        metadata: {
                            size: item.size,
                        },
                        description: item.description ? item.description : null,
                        // images: [],
                    },
                    unit_amount: item.price * 100,
                },
                quantity: item.quantity,
            }));
            items.push({
                price_data: {
                    currency: "chf",
                    product_data: {
                        name: "Shipping",
                    },
                    unit_amount: this.shipping.price * 100,
                },
                quantity: 1,
            });
            axios
                .post(
                    "/api/stripe/checkout/create",
                    {
                        items: items,
                        country: this.country,
                        promos: false,
                    },
                    { auth }
                )
                .then((res) => {
                    return stripe.redirectToCheckout({ sessionId: res.data.id });
                })
                .then((result) => {
                    if (result.error) {
                        alert(result.error.message);
                    }
                });
        },
    }
};
</script>

<style lang="scss" scoped>
.country-select,
.pointer {
    cursor: pointer;
}

.pointer {
    position: relative;
    white-space: nowrap;
}

.pointer:hover {
    opacity: 0.8;
}

.rotate {
    transform: scale(1.1) rotate(45deg);
}

.titlecase {
    text-transform: capitalize;
    display: inline-block !important;
}

.cart {
    position: fixed;
    top: 0;
    right: 0;
    height: 100%;
    width: 100%;
    background: var(--orange);
    transform: translate3d(100%, 0, 0);
    transition: transform 0.5s;
    z-index: 10;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 0;
    overflow: auto;

    &.active {
        transform: translate3d(50%, 0, 0);
    }

    &.checkout {
        transform: translate3d(0, 0, 0);
    }

    @media only screen and (max-width: 768px) {
        grid-template-columns: 1fr;
        grid-template-rows: min-content;
        padding-bottom: var(--lh);

        &.active {
            transform: translate3d(0%, 0, 0);
        }

        &.checkout {
            transform: translate3d(0, 0, 0);
        }
    }

    .cart-half {
        padding: var(--pad);
        grid-column: span 1;
    }
}
</style>
